import { render, staticRenderFns } from "./EgressProfileRealizationScopes.vue?vue&type=template&id=97e37eaa&scoped=true"
import script from "./EgressProfileRealizationScopes.vue?vue&type=script&setup=true&lang=js"
export * from "./EgressProfileRealizationScopes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EgressProfileRealizationScopes.vue?vue&type=style&index=0&id=97e37eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e37eaa",
  null
  
)

export default component.exports